import {Autocomplete, TextField} from "@mui/material";
import React, {useEffect, useRef, useState} from "react";
import {apiGetSchoolList} from "@/modules/schools/services/school.service";
import type {SchoolWithUserDto} from "@/global/api/gen/ts/SchoolWithUserDto";

interface Props {
    onChange: (value: number | null) => void,
}

export function AutocompleteSchool ({ onChange}:Props) {
    const [autocompleteValue, setAutoCompleteValue] = useState<SchoolWithUserDto | null>(null);
    const [inputValue, setInputValue] = useState("");
    const ref = useRef<ReturnType<typeof setTimeout> | null>();
    
    const {data, refetch} = apiGetSchoolList({
        limit: 10,
        offset: 0,
    }, {
        enabled: false
    });

    useEffect(() => {
       void refetch();
    },[]);

    return (
        <Autocomplete
            value={autocompleteValue}
            onChange={(_event, newValue) => {
                onChange(newValue?.id ?? null);
                setInputValue('');
                setAutoCompleteValue(newValue);
            }}
            fullWidth={true}
            inputValue={inputValue}
            onInputChange={(_event, newInputValue) => {
                setInputValue(newInputValue);
                if (!ref.current) {
                    ref.current  = setTimeout(() => {
                        void refetch();
                    }, 500);
                    return;
                }
                clearTimeout(ref.current);
                ref.current  = setTimeout(() => {
                    void refetch();
                }, 500);
            }}
            options={data?.items ?? []}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Поиск автошколы"
                    variant="outlined"
                    fullWidth
                />
            )}
            getOptionLabel={(option) => option.title}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            noOptionsText="Нет подходящих элементов"
        />
    );
}